export const BAR_COLORS = ['#7ABDF4', '#5D95D8', '#4872B8'];
export const COLORS = ['#0071BC', '#39B54A', '#F7931E', '#ED1C24', '#93278F', '#ED1E79'];